import { useEffect, useRef } from 'react';
import { MenuComponent, DrawerComponent, ScrollComponent, ScrollTopComponent, StickyComponent, ToggleComponent } from '../assets/ts/components';
import { useLayout } from './core';

// Module-scope flag prevents duplicate init on re-login
let masterInitDone = false;

export function MasterInit() {
  const { config } = useLayout();
  // for fast refresh in development mode
  const isFirstRun = useRef(true);
  const pluginsInitialization = () => {
    isFirstRun.current = false;
    setTimeout(() => {
      ToggleComponent.bootstrap();
      ScrollTopComponent.bootstrap();
      DrawerComponent.bootstrap();
      StickyComponent.bootstrap();
      MenuComponent.bootstrap();
      ScrollComponent.bootstrap();
    }, 200);
  };

  useEffect(() => {
    if (isFirstRun.current && !masterInitDone) {
      masterInitDone = true;
      isFirstRun.current = false;
      pluginsInitialization();
    }
  }, [config]);

  return <></>;
}
